import { countFormulaSymbols } from './countFormulaSymbols';
import { countQuizTextWith } from './countQuizText';

/**
 * 빌드 폼 저장값(문제 본문·선택형 보기·짝맞추기·순서맞추기 보기의 `text`)의 글자수. `countQuizText`
 * 와 같되 수식을 화면에 보이는 글자 수로 센다(`countFormulaSymbols`). 서버는 수식을 1자
 * (`FORMULA_WEIGHT`)로 세므로 이 값이 항상 크거나 같아, 클라가 통과시킨 값을 서버가 거절하지 않는다.
 *
 * `text` 경로에서만 성립한다 — 서버는 `richText`·`equation` 의 수식도 따로 보지만 zod 는
 * `text` 만 센다.
 */
export const countVisibleQuizText = (text: string): number =>
  countQuizTextWith(text, countFormulaSymbols);
